if (!customElements.get('mx-support-panel')) {
  customElements.define('mx-support-panel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = {signal: this.controller.signal};
      this.dialog = this.querySelector('dialog');
      this.home = this.querySelector('[data-mx-support-home]');
      this.body = this.querySelector('[data-mx-support-body]');
      this.back = this.querySelector('[data-mx-support-back]');
      this.chatButton = this.querySelector('[data-mx-support-chat]');
      this.launcher = this.querySelector('[data-mx-support-launcher]');
      this.answers = [...this.querySelectorAll('[data-mx-support-answer]')];
      if (!this.dialog || !this.home) return;
      document.addEventListener('click', event => {
        const trigger = event.target.closest('[data-mx-support-open]');
        if (!trigger) return;
        event.preventDefault();
        this.open(trigger);
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('a[href]') && this.dialog.open) this.dialog.close();
        const topic = event.target.closest('[data-mx-support-topic]');
        if (topic) this.showAnswer(topic);
        if (event.target.closest('[data-mx-support-back]')) this.showHome(true);
        if (event.target.closest('[data-mx-support-close]') && this.dialog.open) this.dialog.close();
        if (event.target.closest('[data-mx-support-chat]')) this.openInbox();
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }
      }, options);
      this.dialog.addEventListener('close', () => {
        this.restoreScroll();
        document.querySelectorAll('[data-mx-support-open]').forEach(trigger => trigger.setAttribute('aria-expanded', 'false'));
        if (!this.chatHandoff && this.trigger?.isConnected) this.trigger.focus({preventScroll: true});
        this.chatHandoff = false;
      }, options);
      this.documentObserver = new MutationObserver(() => {
        if (!this.inboxHost?.isConnected) this.scheduleInboxSync();
      });
      this.documentObserver.observe(document.body, {childList: true, subtree: true});
      customElements.whenDefined('shopify-chat').then(() => {if (this.isConnected) this.scheduleInboxSync();});
      customElements.whenDefined('shopify-agent-runtime').then(() => {if (this.isConnected) this.scheduleInboxSync();});
      this.syncInboxBridge();
    }
    scheduleInboxSync() {
      if (this.inboxFrame || !this.isConnected) return;
      this.inboxFrame = requestAnimationFrame(() => {
        this.inboxFrame = null;
        this.syncInboxBridge();
      });
    }
    syncInboxBridge() {
      if (!this.isConnected) return;
      const host = document.querySelector('shopify-chat[view="chat"]') || document.querySelector('shopify-chat');
      const shadow = host?.shadowRoot;
      const runtime = shadow?.querySelector('shopify-agent-runtime');
      const panelShadow = runtime?.shadowRoot || shadow;
      if (host !== this.inboxHost || shadow !== this.inboxShadow || runtime !== this.inboxRuntime || panelShadow !== this.inboxPanelShadow) {
        this.inboxObserver?.disconnect();
        this.layoutStyle?.remove();
        this.layoutStyle = null;
        this.inboxHost = host;
        this.inboxShadow = shadow;
        this.inboxRuntime = runtime;
        this.inboxPanelShadow = panelShadow;
        this.inboxAttempts = 0;
        if (typeof this.nativeWasOpen !== 'boolean') this.nativeWasOpen = false;
        if (host) {
          this.inboxObserver = new MutationObserver(() => this.scheduleInboxSync());
          this.inboxObserver.observe(host, {attributes: true, attributeFilter: ['open']});
          if (shadow) this.inboxObserver.observe(shadow, {childList: true, subtree: true, attributes: true, attributeFilter: ['part', 'disabled']});
          if (runtime) this.inboxObserver.observe(runtime, {attributes: true, attributeFilter: ['open', 'shell-ready']});
          if (panelShadow && panelShadow !== shadow) this.inboxObserver.observe(panelShadow, {childList: true, subtree: true, attributes: true, attributeFilter: ['part', 'disabled']});
        }
      }
      this.nativeActivator = panelShadow?.querySelector('button[part~="activator"]') || shadow?.querySelector('button[part~="activator"]');
      const ready = Boolean(this.nativeActivator?.isConnected && !this.nativeActivator.disabled);
      this.toggleAttribute('data-mx-support-bridge-ready', ready);
      if (this.chatButton) this.chatButton.hidden = !ready;
      if (this.launcher) this.launcher.hidden = !ready;
      if (panelShadow && !panelShadow.querySelector('[data-mx-support-layout]')) {
        this.layoutStyle = document.createElement('style');
        this.layoutStyle.setAttribute('data-mx-support-layout', '');
        this.layoutStyle.textContent = '.desktop-layout .panel{left:auto!important;right:max(20px,env(safe-area-inset-right,0px))!important;transform-origin:bottom right!important;}.desktop-layout .panel:not(.panel--size-expanded){width:min(340px,calc(100dvw - 40px))!important;height:min(660px,calc(100dvh - 120px))!important;max-height:calc(100dvh - 120px)!important;}';
        panelShadow.append(this.layoutStyle);
      }
      const nativeOpen = Boolean(runtime?.hasAttribute('open') || host?.hasAttribute('open'));
      this.toggleAttribute('data-mx-support-native-open', nativeOpen);
      if (this.chatOpenedFromSupport && this.nativeWasOpen && !nativeOpen) {
        this.chatOpenedFromSupport = false;
        const focusTarget = this.launcher && !this.launcher.hidden ? this.launcher : this.trigger;
        if (focusTarget?.isConnected) focusTarget.focus({preventScroll: true});
      }
      this.nativeWasOpen = nativeOpen;
      const waitingForRoot = host && (!shadow || (runtime && !runtime.shadowRoot));
      if (waitingForRoot && this.inboxAttempts < 40 && !this.inboxRetry) {
        this.inboxAttempts += 1;
        this.inboxRetry = setTimeout(() => {
          this.inboxRetry = null;
          this.syncInboxBridge();
        }, 250);
      }
      if (ready && !waitingForRoot && this.inboxRetry) {
        clearTimeout(this.inboxRetry);
        this.inboxRetry = null;
      }
    }
    openInbox() {
      this.syncInboxBridge();
      if (!this.nativeActivator?.isConnected || this.nativeActivator.disabled) return;
      this.chatHandoff = true;
      this.chatOpenedFromSupport = true;
      if (this.dialog.open) this.dialog.close();
      this.restoreScroll();
      if (!this.inboxHost.hasAttribute('open') && !this.inboxRuntime?.hasAttribute('open')) this.nativeActivator.click();
    }
    open(trigger) {
      if (this.dialog.open) return;
      this.trigger = trigger;
      this.showHome(false);
      this.dialog.showModal();
      this.scrollValues = {html: document.documentElement.style.overflow, body: document.body.style.overflow};
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      document.querySelectorAll('[data-mx-support-open]').forEach(button => button.setAttribute('aria-expanded', 'true'));
      this.home.querySelector('[data-mx-support-topic]')?.focus({preventScroll: true});
    }
    showAnswer(trigger) {
      const answer = this.answers.find(panel => panel.dataset.mxSupportAnswer === trigger.dataset.mxSupportTopic);
      if (!answer) return;
      this.topicTrigger = trigger;
      this.home.hidden = true;
      this.answers.forEach(panel => {panel.hidden = panel !== answer;});
      this.back.hidden = false;
      this.querySelectorAll('[data-mx-support-topic]').forEach(button => button.setAttribute('aria-expanded', String(button === trigger)));
      const heading = answer.querySelector('h2');
      this.dialog.setAttribute('aria-labelledby', heading.id);
      this.body.scrollTop = 0;
      heading.focus({preventScroll: true});
    }
    showHome(restoreFocus) {
      this.home.hidden = false;
      this.answers.forEach(panel => {panel.hidden = true;});
      this.back.hidden = true;
      this.querySelectorAll('[data-mx-support-topic]').forEach(button => button.setAttribute('aria-expanded', 'false'));
      this.dialog.setAttribute('aria-labelledby', this.home.querySelector('h2').id);
      this.body.scrollTop = 0;
      if (restoreFocus) this.topicTrigger?.focus({preventScroll: true});
    }
    restoreScroll() {
      if (!this.scrollValues) return;
      document.documentElement.style.overflow = this.scrollValues.html;
      document.body.style.overflow = this.scrollValues.body;
      this.scrollValues = null;
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restoreScroll();
      this.documentObserver?.disconnect();
      this.inboxObserver?.disconnect();
      this.layoutStyle?.remove();
      clearTimeout(this.inboxRetry);
      cancelAnimationFrame(this.inboxFrame);
      this.inboxRetry = null;
      this.inboxFrame = null;
      this.removeAttribute('data-mx-support-bridge-ready');
      this.removeAttribute('data-mx-support-native-open');
      this.controller?.abort();
      this.controller = null;
    }
  });
}
